import ApiConfig from "../config/Api.config";
import Cliente from "../interfaces/Cliente.interface";
import Request from "../interfaces/Request.interface";
import Response from "../interfaces/Response.interface";

const url = `${ApiConfig.URLBase}/cliente`

const guardar = async (cliente: Cliente): Promise<Response> => {    
    const request: Request = {
        url: `${url}/guardar`,
        metodo: "POST",
        data: {
            cliente
        }
    }
    const response: Response = await ApiConfig.executeRequest(request);
    return response;
};

const listar = async (texto: string): Promise<Response> => {

    const request: Request = {
        url: `${url}/listar`,
        metodo: "POST",
        data: {
            texto
        }
    }
    const response: Response = await ApiConfig.executeRequest(request);
    return response;
};

const obtenerPorId = async (IdCliente: number): Promise<Response> => {    
    const request: Request = {
        url: `${url}/${IdCliente}`,
        metodo: "GET",
    }
    const response: Response = await ApiConfig.executeRequest(request);
    return response;
};


const ClienteService = {
    guardar,
    listar,
    obtenerPorId
};

export default ClienteService;